/**
 * @fileoverview Selectors for list state
 * @see {@link src/store/newLists/newLists.slice.ts} - State management
 */

import type { RootState } from '@/store/index';

/** Get all available lists */
const getAllLists = () => (state: RootState) => state.newLists.allLists;

/** Get currently active list */
const getCurrentList = () => (state: RootState) => state.newLists.currentNewList;

/** Get list parameters (pagination, etc) */
const getListParams = () => (state: RootState) => state.newLists.listParams;

const newListSelectors = { getAllLists, getCurrentList, getListParams };
export default newListSelectors;
